import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Block {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async getBlockById(id) {
        const params = {
            id: id,
        };
        const res = await this.base.get('/api/blocks/getBlock', params);
        const result = res.data;
        return result;
    }
    async getBlockByHeight(height) {
        const params = {
            height: height,
        };
        const res = await this.base.get('/api/blocks/getBlock', params);
        const result = res.data;
        return result;
    }
    async getBlocks(offset, limit, orderBy, transactions) {
        const params = {
            offset: offset,
            limit: limit,
            orderBy: orderBy,
            transactions: transactions,
        };
        const res = await this.base.get('/api/blocks', params);
        // TODO: add error type
        const result = res.data;
        return result;
    }
    async getHeight() {
        const res = await this.base.get('/api/blocks/getHeight');
        const result = res.data;
        return result;
    }
    async getMilestone() {
        const res = await this.base.get('/api/blocks/getMilestone');
        const result = res.data;
        return result;
    }
    async getReward() {
        const res = await this.base.get('/api/blocks/getReward');
        const result = res.data;
        return result;
    }
    async getSupply() {
        const res = await this.base.get('/api/blocks/getSupply');
        const result = res.data;
        return result;
    }
    async getStatus() {
        const res = await this.base.get('/api/blocks/getStatus');
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=block.js.map